import { render, staticRenderFns } from "./DraggableMultimedia.vue?vue&type=template&id=ff22b26c&"
import script from "./DraggableMultimedia.vue?vue&type=script&lang=js&"
export * from "./DraggableMultimedia.vue?vue&type=script&lang=js&"
import style0 from "./DraggableMultimedia.vue?vue&type=style&index=0&id=ff22b26c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports